import React from 'react';
import { usePageTitle } from '@lib/common';
import { PurchaseTransactionReport } from '../components';

export const PurchaseTransactionPage: React.FC = () => {
  usePageTitle('Purchase Transaction Report');
  return <PurchaseTransactionReport />;
};
